/**
 * @returns Money or an empty object if price is undefined.
 */

export const getVariantPrice = (variant, currency) => {
  var _variant$pricingStrat;
  const value = (_variant$pricingStrat = variant.pricingStrategies) == null || (_variant$pricingStrat = _variant$pricingStrat[0]) == null || (_variant$pricingStrat = _variant$pricingStrat.flatRate) == null ? void 0 : _variant$pricingStrat.amount;
  return value && currency ? {
    value,
    currency
  } : {};
};
//# sourceMappingURL=get-variant-price.js.map